import { stats } from '@/mocks/data';

export default function StatsBar() {
  return (
    <section className="relative -mt-16 z-20">
      <div className="w-full max-w-[960px] mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`flex flex-col items-center justify-center py-6 px-4 ${
                index < stats.length - 1 ? 'border-b md:border-b-0 md:border-r border-background-200/70' : ''
              } ${index < 2 ? 'border-r md:border-r' : ''} ${index >= 2 ? '' : ''}`}
            >
              <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</span>
              <span className="text-xs md:text-sm text-foreground-600 mt-1">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}